var React = require('react');

function Box (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.5 11.2L21.5 4.84C20.58 4.3 19.42 4.3 18.5 4.84L7.5 11.2C6.58 11.74 6 12.72 6 13.8V26.5C6 27.58 6.58 28.56 7.5 29.1L18.5 35.46C19.42 36 20.58 36 21.5 35.46L32.5 29.1C33.42 28.56 34 27.58 34 26.5V13.8C34 12.72 33.42 11.74 32.5 11.2ZM10 25.92V16.68L18 21.32V30.54L10 25.92ZM20 17.86L12 13.22L20 8.6L28 13.22L20 17.86ZM22 30.54V21.32L30 16.68V25.92L22 30.54ZM10 0H3C1.34 0 0 1.34 0 3V10H4V4H10V0ZM30 0H37C38.66 0 40 1.34 40 3V10H36V4H30V0ZM10 40H3C1.34 40 0 38.66 0 37V30H4V36H10V40ZM30 40H37C38.66 40 40 38.66 40 37V30H36V36H30V40Z","fill":"currentColor"}));
}

Box.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Box;

Box.default = Box;
